import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { nzDateTime } from "@/lib/hsUtil";

const FlagList = ({ flags, onAck }) => (
  <div className="card border-amber-500 space-y-2" data-testid="hs-midnight-flags">
    <h3 className="text-amber-400">Still signed in at midnight ({flags.length})</h3>
    <div className="text-xs opacity-70">These people did not sign out and were signed out automatically. Check they left site safely.</div>
    {flags.map(f => (
      <div key={f.id} className="flex items-center justify-between gap-2 text-sm border-t border-neutral-800 pt-2" data-testid={`hs-flag-${f.id}`}>
        <div>{f.name} <span className="opacity-60">({f.company}) · {f.project} · in {nzDateTime(f.signed_in_at)}</span></div>
        <button className="btn-ghost text-xs" onClick={() => onAck(f.id)} data-testid={`hs-flag-ack-${f.id}`}>Checked</button>
      </div>
    ))}
  </div>
);

export default function OnSiteTab() {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/hs/on-site").then(r => setD(r.data)), []);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);
  if (!d) return <div className="opacity-70">Loading…</div>;
  const ack = async id => { await api.post(`/hs/visits/${id}/ack-flag`); load(); };
  return (
    <div className="space-y-4" data-testid="hs-onsite-tab">
      {d.flags.length > 0 && <FlagList flags={d.flags} onAck={ack}/>}
      <div className="card overflow-x-auto">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-silver">On site now: <span data-testid="hs-onsite-count">{d.on_site.length}</span></h3>
          <button className="btn-ghost text-sm" onClick={load} data-testid="hs-onsite-refresh">Refresh</button>
        </div>
        <table className="table w-full text-sm">
          <thead><tr><th>Name</th><th>Company</th><th>Type</th><th>Phone</th><th>Project</th><th>Signed in</th></tr></thead>
          <tbody>
            {d.on_site.map(v => (
              <tr key={v.id} data-testid={`hs-onsite-row-${v.id}`}>
                <td>{v.name}</td><td>{v.company}</td><td>{v.type}</td><td>{v.phone}</td><td>{v.project}</td><td>{nzDateTime(v.signed_in_at)}</td>
              </tr>
            ))}
            {d.on_site.length === 0 && <tr><td colSpan={6} className="opacity-60">Nobody is signed in right now.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
